
import { useState } from 'react';

export default function TestimonialsSection() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  
  const testimonials = [
    {
      name: 'Sarah Johnson',
      position: 'CTO, FinanceFlow Inc.',
      company: 'Financial Services',
      content: 'SHANGALO DIGITAL transformed our entire IT infrastructure. Their cloud migration strategy reduced our costs by 40% while improving performance significantly. The team\'s expertise and professionalism exceeded our expectations.',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/5313d36bed1823eb3a48b6fa48c0d900.jpg'
    },
    {
      name: 'Dr. Michael Chen',
      position: 'Principal Dentist, SmileCare Dental',
      company: 'Dental Practice',
      content: 'SHANGALO DIGITAL created an outstanding website for our dental practice. The modern design and online booking system have increased our patient appointments by 60%. Their understanding of healthcare needs was exceptional.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20male%20dentist%20in%20white%20coat%2C%20confident%20dental%20professional%2C%20medical%20headshot%20with%20clean%20background%2C%20healthcare%20professional%20portrait%2C%20dental%20clinic%20setting&width=100&height=100&seq=testimonial-2&orientation=squarish'
    },
    {
      name: 'Dr. Ballisto Rodriguez',
      position: 'Veterinarian, PetCare Animal Hospital',
      company: 'Veterinary Clinic',
      content: 'SHANGALO DIGITAL delivered an incredible website and AI automation system for our veterinary clinic. The automated appointment reminders and patient management system have streamlined our operations completely. Outstanding work!',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20female%20veterinarian%20in%20medical%20scrubs%2C%20confident%20animal%20healthcare%20professional%2C%20veterinary%20clinic%20headshot%20with%20clean%20background%2C%20pet%20healthcare%20professional%20portrait&width=100&height=100&seq=testimonial-3&orientation=squarish'
    },
    {
      name: 'David Thompson',
      position: 'Operations Manager, ManufacturingPro',
      company: 'Manufacturing',
      content: 'SHANGALO DIGITAL optimized our manufacturing systems and integrated IoT solutions that increased our operational efficiency by 35%. Their ongoing support and digital transformation expertise has been invaluable.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20businessman%20operations%20manager%20in%20manufacturing%20environment%2C%20confident%20male%20industrial%20professional%2C%20corporate%20headshot%20with%20clean%20background%2C%20professional%20manufacturing%20industry%20attire&width=100&height=100&seq=testimonial-4&orientation=squarish'
    },
    {
      name: 'Lisa Williams',
      position: 'CEO, RetailMax Solutions',
      company: 'E-commerce',
      content: 'The cybersecurity audit and e-commerce platform development by SHANGALO DIGITAL was comprehensive and thorough. They identified vulnerabilities we didn\'t know existed and built us a secure, high-performing online store.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20businesswoman%20CEO%20in%20modern%20office%2C%20confident%20female%20executive%2C%20corporate%20headshot%20with%20clean%20background%2C%20professional%20business%20attire%2C%20leadership%20portrait&width=100&height=100&seq=testimonial-5&orientation=squarish'
    }
  ];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            What Our Clients Say
          </h2>
          <p className="text-xl text-gray-600">
            Don't just take our word for it - hear from our satisfied clients
          </p>
        </div>
        
        <div className="relative max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <div className="flex items-center mb-6">
              {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                <div key={i} className="w-5 h-5 flex items-center justify-center mr-1">
                  <i className="ri-star-fill text-yellow-400"></i>
                </div>
              ))}
            </div>
            
            <blockquote className="text-xl text-gray-700 mb-8 leading-relaxed">
              "{testimonials[currentTestimonial].content}"
            </blockquote>
            
            <div className="flex items-center">
              <img 
                src={testimonials[currentTestimonial].image}
                alt={testimonials[currentTestimonial].name}
                className="w-16 h-16 rounded-full object-cover mr-4"
              />
              <div>
                <div className="font-semibold text-gray-900">
                  {testimonials[currentTestimonial].name}
                </div>
                <div className="text-emerald-600">
                  {testimonials[currentTestimonial].position}
                </div>
                <div className="text-gray-600 text-sm">
                  {testimonials[currentTestimonial].company}
                </div>
              </div>
            </div>
          </div>
          
          <button 
            onClick={prevTestimonial}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-arrow-left-line text-gray-600"></i>
            </div>
          </button>
          
          <button 
            onClick={nextTestimonial}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-arrow-right-line text-gray-600"></i>
            </div>
          </button>
          
          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentTestimonial(index)}
                className={`w-3 h-3 rounded-full transition-colors cursor-pointer ${
                  index === currentTestimonial ? 'bg-emerald-600' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
